import { UserSocketEvent } from '/@/modules/core/app/events/UserSocketEvent';
import { SocketEventType } from '/@/modules/core/app/constants/SocketEventType';
import { UserNotifyType } from '@/modules/user/constants/UserNotifyType';

export class NotifyUserSocketEvent extends UserSocketEvent {
  type?: UserNotifyType;

  message?: string;

  constructor(model: Partial<NotifyUserSocketEvent> = {}) {
    super(model);

    this.type = model.type;
    this.message = model.message;
  }

  static getEventName(): string {
    return SocketEventType.NOTIFY_USER_SOCKET_EVENT;
  }
}
